export const HI="hi";
export const EN="en";